<template>
  <div class="homePage">
    <div class="homePage-top">
      <totel asset="" class="totel"></totel>
    </div>
    <echart class="homePage-center"></echart>
    <div class="homePage-bottom">
      <systemnews></systemnews>
    </div>
  </div>
</template>

<script>
  import totel from '@/components/TotelMoney'
  import day from '@/components/DayDeal'
  import echart from '@/components/echarts'
  import systemnews from '@/components/SystemNews'
  export default {
    components: {
      totel,
      day,
      systemnews,
      echart,
    }
  }
</script>

<style lang="scss" scoped>
  @import '../style/_variables';
  @import '../style/mixin';
  .homePage {
    background-color: #e4e9ec;
    > .homePage-top {
      height: 120px;
      width: 100%;
      @include flex-row;
      justify-content: space-between;
      > .totel {
        flex: 1;
      }
      > .day {
        flex: 2;
        margin-left: 10px;
      }
    }
    > .homePage-center {
      margin: 16px 16px 0 16px;
      background-color: #fff;
    }
    > .homePage-bottom {
      margin: 16px 16px 0 16px;
      background-color: #fff;

    }
  }
</style>




// WEBPACK FOOTER //
// src/pages/HomePage.vue